<template>
  <div class="producer-password common-page">
    <!-- 面包屑 -->
    <a-breadcrumb>
      <a-breadcrumb-item>生产者管理</a-breadcrumb-item>
      <a-breadcrumb-item>修改生产者密码</a-breadcrumb-item>
    </a-breadcrumb>

    <section class="common-box">
      <div class="common-box-title">修改生产者密码</div>
      <div class="common-box-body">
        <a-form :form="form" style="width:600px;">
          <a-form-item label="新密码" extra="密码必须包含字母和数字，长度在6~20位之间" v-bind="formItemLayout">
            <a-input
              placeholder="请输入新密码"
              v-decorator="[ 'password',
                {
                  rules: [
                    {
                      required: true, message: '请输入新密码',
                    }, 
                    {
                      validator: validateToNextPassword,
                    },
                    {
                      pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z_]{6,20}$/, message: '密码格式错误'
                    }
                  ],
                  validateTrigger:'blur'
                }
              ]"
              type="password"
            />
          </a-form-item>

          <a-form-item label="确认密码" v-bind="formItemLayout">
            <a-input
              placeholder="请再次输入新密码"
              v-decorator="[ 'confirm',
                  {
                    rules: [{
                      required: true, message: '请再次输入新密码',
                    }, {
                      validator: compareToFirstPassword,
                    }],
                  }
                ]"
              type="password"
              @blur="handleConfirmBlur"
            />
          </a-form-item>

          <a-form-item label :wrapper-col="{ span: 12, offset: 4 }">
            <a-button type="primary" @click="submit" :loading="loading">提交</a-button>
          </a-form-item>
        </a-form>
      </div>
    </section>
  </div>
</template>

<script>
import { editProducerPassword } from '../api/api'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 }
  }
}

export default {
  name: 'producer-password',

  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout,
      loading: false
    }
  },

  computed: {
    producerUserName() {
      return this.$route.query.producerUserName
    }
  },

  methods: {
    /**确认密码 start*/
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback('两次密码不一致')
      } else {
        callback()
      }
    },

    validateToNextPassword(rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true })
      }
      callback()
    },

    handleConfirmBlur(e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    /**确认密码 end*/

    submit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          editProducerPassword(this.producerUserName, values.password).then(res => {
            if (res.error.code === 0) {
              this.form.resetFields()
              this.$message.success('修改成功')
            }
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.producer-password {
}
</style>